module.exports = __webpack_public_path__ + "img/footer_logo.17a95e10.png";